import React, { useState } from "react";
import { useAuth } from "../context/authContext";
import { Link, useNavigate } from "react-router-dom";
import { Alert } from "./Alert";
import logo from "../assets/Logo.png";
import { updateProfile } from "firebase/auth"; // 👈 importa esto arriba
import { auth } from "../firebase";


export function Register() {
  const { signup, GuardarEnLocal, Estado, sincronizarUsuarioYDispositivo } = useAuth();
  const navigate = useNavigate();

  const [user, setUser] = useState({ email: "", password: "" });
  const [nombre, setNombre] = useState("");
  const [error, setError] = useState("");

  const frases = [
    "El primer paso hacia tus metas empieza hoy 💪",
    "Regístrate y supera tus límites 🚴‍♂️",
    "Cada pedalada cuenta, incluso la primera 🚀",
  ];
  const frase = frases[Math.floor(Math.random() * frases.length)];

  const handleChange = ({ target: { name, value } }) => {
    setUser({ ...user, [name]: value });
  };

  const handleNombre = (e) => {
    const nuevoNombre = e.target.value;
    setNombre(nuevoNombre);
    localStorage.setItem("nombre", JSON.stringify(nuevoNombre));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  try {
    // 1. Crear usuario en Firebase Auth
    const userCredential = await signup(user.email, user.password);
    const uid = userCredential.user.uid;

    // 2. Guardar el nombre en Firebase Auth (displayName)
    await updateProfile(userCredential.user, { displayName: nombre });
    console.log("✅ Nombre guardado en Firebase Auth Register:", nombre);

    // 3. Hacer reload para que coja el nombre actualizado
    await auth.currentUser.reload(); 
    console.log("✅ Nombre tras reload:", auth.currentUser.displayName);

    // 4. Sincronizar usuario y dispositivo con el nombre correcto
    await sincronizarUsuarioYDispositivo(uid, auth.currentUser.displayName, user.email);

    // 5. Guardar en local y estado
    await GuardarEnLocal(uid);
    await Estado(uid);

    localStorage.setItem("PuntosSesion", 0);
    localStorage.setItem("PuntosTotales", 0);

    // 6. Redirigir a comprobación
    navigate("/Comprobacion");
  } catch (error) {
    setError(error.message);
  }
};

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800">
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-xl p-8 w-[350px] text-center">
        {error && <Alert message={error} />}

        <img src={logo} alt="Logo" className="mx-auto w-40" />

        <h1 className="text-2xl font-bold text-white mb-6">🚀 Crea tu cuenta</h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              name="name"
              placeholder="Nombre"
              className="bg-white/20 text-white placeholder-gray-300 rounded-lg w-full py-3 px-4 focus:outline-none focus:ring-2 focus:ring-green-500"
              onChange={handleNombre}
              required
            />
          </div>

          <div>
            <input
              type="email"
              name="email"
              placeholder="tuemail@gmail.com"
              onChange={handleChange}
              className="bg-white/20 text-white placeholder-gray-300 rounded-lg w-full py-3 px-4 focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          <div>
            <input
              type="password"
              name="password"
              placeholder="******"
              onChange={handleChange}
              className="bg-white/20 text-white placeholder-gray-300 rounded-lg w-full py-3 px-4 focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-green-500 hover:bg-green-600 text-white py-3 rounded-xl font-semibold transition"
          >
            Regístrate
          </button>
        </form>

        <p className="mt-6 text-sm text-gray-300">
          ¿Ya tienes una cuenta?{" "}
          <Link to="/login" className="underline hover:text-white">
            Login
          </Link>
        </p>

        <p className="mt-6 text-sm italic text-gray-200">{frase}</p>
      </div>
    </div>
  );
}

export default Register;
